import { ALGOS_E } from "@constants/Algos";
import { PostRequest } from "./http/BaseRequest";
import W2UiFilterBuilder from "./w2ui";
import { BaseResponse } from "./http/responses/BaseResponse";

export interface IMinerProfileBase {
  readonly id: number;
  readonly name: string;
  readonly consumption: number;
  readonly performance: number;
  readonly hash: ALGOS_E;
  readonly meta: IMinerProfileMeta;
}

export interface IMinerProfileMeta {
  readonly width?: number;
  readonly height?: number;
  readonly depth?: number;
  readonly err?: number;
  readonly efficiency?: number;
}

export interface IMinerProfilesResponse extends BaseResponse {
  readonly Records: IMinerProfileBase[];
  readonly Total: number;
}

export class GetMinerProfiles extends PostRequest {
  constructor(offset = 0, limit = 200) {
    const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
    let params = builder.build().stringParams;

    super("/miner/profile/list", params);
  }
}

export interface IAddMinerProfileParams {
  readonly name: string;
  readonly hash: ALGOS_E;
  readonly consumption: number;
  readonly performance: number;
  readonly meta: string;
  readonly edit?: boolean;
  readonly id?: number;
}

export interface AddMinerProfileResponse extends BaseResponse {
  Record: number;
}

export class AddMinerProfile extends PostRequest {
  constructor(params: IAddMinerProfileParams) {
    super("/admin/miner/profile/add", params);
  }
}

export class DeleteMinerProfile extends PostRequest {
  constructor(mid: number) {
    super("/admin/miner/profile/delete", { mid });
  }
}
